import styled from 'styled-components';

const Wrapper = styled.div `
  max-width: 100%;
  width: 400px;
`;
const Footer = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;
const getStripeStyles = (theme) => ({
    rules: {
        '.Input': {
            border: '1px solid rgba(11, 31, 28, 0.48)',
        },
        '.Label': {
            fontWeight: '700',
        },
        '.Tab': {
            border: '1px solid rgba(11, 31, 28, 0.48)',
        },
        '.Tab:disabled': {
            color: 'rgba(11, 31, 28, 0.48)',
        },
        '.Tab:focus': {
            backgroundColor: theme.colors.background.secondary,
            border: '2px solid',
            borderColor: theme.colors.content.accent9,
        },
        '.Tab:hover': {
            color: 'var(--colorText)',
        },
        '.Tab--selected': {
            backgroundColor: theme.colors.background.secondary,
            borderColor: theme.colors.content.accent9,
        },
        '.Link': {
            textDecoration: 'underline',
        },
    },
    theme: 'none',
    variables: {
        borderRadius: theme.borderRadii.small,
        colorDanger: theme.colors.content.error,
        colorSuccess: theme.colors.content.success,
        colorIconCardError: theme.colors.content.error,
        colorIconCardCvcError: theme.colors.content.error,
        colorIconTabHover: theme.colors.content.primary,
        colorIconTabSelected: theme.colors.content.accent9,
        colorPrimary: theme.colors.content.primary,
        colorText: theme.colors.content.primary,
        colorTextPlaceholder: theme.colors.content.secondary,
        colorTextSecondary: theme.colors.content.secondary,
        fontFamily: "'DM Sans', sans-serif",
        fontSizeBase: '16px',
        fontSizeXs: '16px',
        spacingGridRow: '24px',
    },
});

export { Footer, Wrapper, getStripeStyles };
